import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { RoleFilter } from "@shared/interfaces";

export default {
  getUserDetails: () => request(METHODS.GET, API.USER.GET_USER_DETAILS)(),
  getRoles: (filter: RoleFilter) => request(METHODS.GET, API.SHARED.GET_ROLES)({ params: filter }),
  getPermissions: () => request(METHODS.GET, API.SHARED.GET_PERMISSIONS)(),
};
